import React from 'react';
import {
  Text,
  Image,
  isExperienceEditorActive,
} from '@sitecore-jss/sitecore-jss-react';
import { DefaultProps, PropTypes } from '../../../core/Utils/SitecoreFields';
import ScrollAnimation from 'react-animate-on-scroll';

class Testimonial extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      userName,
      userIntro,
      userPhoto,
      userSaid,
      hasFade,
      wrapWithQuotes,
      backgroundColorOption,
    } = this.props.fields;
    const bgc = backgroundColorOption[0].fields.color.value;
    const bgi = backgroundColorOption[0].fields.backgroundImage.value.src;
    const cssClassNoQuotes =
      wrapWithQuotes !== undefined && wrapWithQuotes.value === true
        ? ''
        : ' no-quotes';
    const contentBlock = (
      <div
        className="testimonial"
        style={{
          backgroundColor: bgc,
          backgroundImage: 'url(' + bgi + ')',
        }}
      >
        <div className="l-padding">
          <div className={`testimonial-content${cssClassNoQuotes}`}>
            <div className="people-intro mb-show">
              <Image field={userPhoto} />
              <div className="details">
                <Text field={userName} tag="p" className="name" />
                <Text field={userIntro} tag="p" className="intro" />
              </div>
            </div>

            <div className="title">
              <Text field={userSaid} tag="h2" />
            </div>

            <div className="people-intro pc-show">
              <Image field={userPhoto} />
              <div className="details">
                <Text field={userName} tag="p" className="name" />
                <Text field={userIntro} tag="p" className="intro" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    return hasFade && hasFade.value ? (
      <ScrollAnimation
        animateIn="toFadeInUp"
        animateOnce
        delay={100}
        duration={0.5}
      >
        {contentBlock}
      </ScrollAnimation>
    ) : (
      contentBlock
    );
  }
}

Testimonial.propTypes = PropTypes.SitecoreItem.inject({
  userName: PropTypes.SingleLineText,
  userIntro: PropTypes.SingleLineText,
  userPhoto: PropTypes.Image,
  userSaid: PropTypes.MultiLineText,
  hasFade: PropTypes.Checkbox,
  backgroundColorOption: PropTypes.Multilist.inject({
    color: PropTypes.SingleLineText,
    backgroundImage: PropTypes.Image,
  }),
});

Testimonial.defaultProps = DefaultProps.SitecoreItem.inject({
  userName: DefaultProps.SingleLineText,
  userIntro: DefaultProps.SingleLineText,
  userPhoto: DefaultProps.Image,
  userSaid: DefaultProps.MultiLineText,
  hasFade: DefaultProps.Checkbox,
  backgroundColorOption: DefaultProps.Multilist.inject,
});

export default Testimonial;
